import { FiSearch } from "react-icons/fi";
import { ArrowLeft, ListTodo, Trash2 } from "lucide-react";

import { useNavigate } from "react-router-dom";

export default function Header({ toggleSelectAll, deleteSelected, selected }) {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-3 items-center px-4 py-3 border-b-2 border-[var(--background)]">
      {/* LEFT */}
      <div className="flex">
        <button
           onClick={() => navigate(-1)}
          className="p-2 transition"
        >
          <ArrowLeft className="w-5 h-5 text-[var(--text)]" />
        </button>
      </div>

      {/* CENTER */}
      <h1 className={`text-lg font-bold ${selected.length > 0 ? "text-left" : "text-center"} `}>Quotes</h1>

      {/* RIGHT */}
      <div className="flex justify-end gap-3">
        {/* Search Symbol */}
        {selected.length > 0 ? (
          <button
            onClick={deleteSelected}
            className="p-2 transition"
          >
            <Trash2 className="w-5 h-5 text-[var(--sellmeta)]" />
          </button>
        ) : null}

        <button
          onClick={toggleSelectAll}
          className="p-2 transition"
        >
          <ListTodo className="w-5 h-5 text-[var(--text)]" />
        </button>

        {/* Add Symbol */}
        <button
          onClick={() => navigate("/AddSymbol")}
          className="p-2 transition"
        >
          <FiSearch className="w-5 h-5 text-[var(--text)]" />
        </button>
      </div>
    </div>
  );
}
